import http from "../http-common";
import authHeader from "../../services/auth-header";

const record = (data) => {
  return http.post("/stamp-duty", data, { headers: authHeader() });
};

const getSummary = (params) => {
  return http.get("/stamp-duty/summary", { headers: authHeader(), params });
};

const StampDutyService = {
  record,
  getSummary
};

export default StampDutyService;
